import { Button } from "@components/common/button"
import { DictType } from "@pma/types"
import { Scissors } from "lucide-react"
import useTranslator from "@hooks/use-translator"
import { Tooltip, TooltipContent, TooltipTrigger } from "@components/common/tooltip"
import { toast } from "@pma/hooks/use-toast"
import React from "react"

interface Props {
  file?: DictType
  fileArr?: DictType[]
  activeFolder: any
  setCutFiles: (files: DictType[]) => void
  handleBatchSelection?: () => void
  setFolderItems: React.Dispatch<React.SetStateAction<{ [id: number]: any[] }>>
  folderItems: { [id: number]: any[] }
  setPreFolderItems: React.Dispatch<React.SetStateAction<{ [id: number]: any[] }>>
  isMenuView?: boolean
  setFolderId: React.Dispatch<React.SetStateAction<number>>
}

export default function CutFile({
  file,
  fileArr,
  activeFolder,
  folderItems,
  setCutFiles,
  handleBatchSelection,
  setFolderItems,
  setPreFolderItems,
  setFolderId,
  isMenuView,
}: Props) {
  const { translate } = useTranslator()

  const handleCut = () => {
    if (file) {
      setFolderId(activeFolder.id)
      setPreFolderItems(folderItems)
      const existingItems = folderItems[activeFolder.id]
      const newItems = existingItems.filter((item) => item.id != file.id)
      setFolderItems({ ...folderItems, [activeFolder.id]: newItems })
      setCutFiles([file])
    } else if (fileArr && fileArr.length > 0) {
      setFolderId(activeFolder.id)
      setPreFolderItems(folderItems)
      const idsArray = fileArr.map((item) => item.id)
      const existingItems = folderItems[activeFolder.id]
      const newItems = existingItems.filter((item) => !idsArray.includes(item.id))
      setFolderItems({ ...folderItems, [activeFolder.id]: newItems })
      setCutFiles(fileArr)
      if (handleBatchSelection) {
        handleBatchSelection()
      }
    }

    toast({
      title: translate("Success"),
      description: translate("Your file has been cut"),
      variant: "success",
    })
  }

  return isMenuView ? (
    <div className='flex items-center gap-2 rounded hover:bg-muted' onClick={handleCut}>
      <div className='px-2'>
        <Scissors size={16} />
      </div>
      <span className='text-sm'>{translate("Cut file")}</span>
    </div>
  ) : (
    <Tooltip>
      <TooltipTrigger asChild>
        {file ? (
          <Button size='icon' className='h-6 w-7' variant='ghost' onClick={handleCut}>
            <Scissors className='h-4 w-4' />
          </Button>
        ) : (
          <Button
            variant='outline'
            size='sm'
            onClick={handleCut}
            disabled={!fileArr || fileArr.length === 0}
            className='flex items-center gap-1'
          >
            <Scissors size={14} />
            <span className='hidden min-w-[30px] text-left text-[12px] sm:block sm:text-[10px]'>
              {translate("Cut selected files")}
            </span>
          </Button>
        )}
      </TooltipTrigger>
      <TooltipContent>
        {file ? translate("Cut file") : translate("Cut selected files")}
      </TooltipContent>
    </Tooltip>
  )
}
